<app-document-viewer-page [label]="title" [url]="url">
</app-document-viewer-page>

